import { testimonials } from "@/mocks/testimonials";

const stats = [
  { value: "5", label: "主题板块持续更新", icon: "ri-layout-grid-line" },
  { value: "24h", label: "全天候滚动不停更", icon: "ri-time-line" },
  { value: "3", label: "可信度标注等级", icon: "ri-shield-check-line" },
  { value: "0", label: "浏览需要注册门槛", icon: "ri-lock-unlock-line" },
];

const principles = [
  {
    icon: "ri-route-line",
    title: "先排时间线，再谈观点",
    desc: "我们优先把事情的先后顺序还原清楚，让读者自己看节奏，而不是替读者下结论。",
  },
  {
    icon: "ri-verified-badge-line",
    title: "每条快讯都标可信度",
    desc: "已证实、多方讨论、待核实三档一目了然，避免把单一来源的说法当成定论。",
  },
  {
    icon: "ri-links-line",
    title: "只整理公开渠道内容",
    desc: "快讯来自公开讨论与公开内容，我们做的是整理与串联，不制造、不推动未经确认的说法。",
  },
  {
    icon: "ri-delete-bin-6-line",
    title: "错了就改，改了就标",
    desc: "收到纠错会尽快核对并更新条目，重要的更正会在时间线上单独说明。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 w-full bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true"></span>
              关于瓜田速递
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-950 leading-tight">
              站在时间线这一侧看热点
            </h2>
            <div className="mt-5 flex flex-col gap-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                瓜田速递是一个专注娱乐快讯推送的内容站。我们不追着做「最全」，而是想把
                <strong className="text-foreground-950 font-medium"> 正在发生的动静 </strong>
                按时间线提到最前面，让你打开就知道此刻大家在讨论什么、有哪些配套截图、事情正往哪个方向走。
              </p>
              <p>
                网站定位很明确：给不蹲群、不刷遍全网、但又不想错过第一时间的人一个入口。所以实时快报、24 小时滚动更新、来源标注，这三件事是我们一直坚持的。
              </p>
              <p>
                品牌理念说出来也简单——热闹可以看得更快，判断还是得留给自己。我们负责把脉络理清楚，怎么理解交给你。
              </p>
            </div>

            <div className="mt-7 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <h3 className="font-heading text-lg text-foreground-950">内容原则</h3>
              <ul className="mt-3 flex flex-col gap-3">
                {principles.map((item) => (
                  <li key={item.title} className="flex items-start gap-3">
                    <span className="shrink-0 w-8 h-8 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-950">{item.title}</p>
                      <p className="mt-0.5 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {stats.map((item) => (
                <div
                  key={item.label}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center">
                    <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <p className="mt-3 font-heading text-3xl text-foreground-950 leading-none">{item.value}</p>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600">{item.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-center gap-2">
                <i className="ri-chat-quote-line text-xl text-primary-500" aria-hidden="true"></i>
                <h3 className="font-heading text-lg text-foreground-950">大家都在怎么说</h3>
              </div>
              <ul className="mt-4 flex flex-col gap-4 max-h-[360px] overflow-y-auto pr-1">
                {testimonials.map((item) => (
                  <li key={item.id} className="flex items-start gap-3">
                    <span className="shrink-0 w-9 h-9 rounded-full bg-secondary-100 text-secondary-900 flex items-center justify-center font-heading text-base">
                      {item.initial}
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
                      <p className="mt-1.5 text-xs text-foreground-500">
                        <span className="text-foreground-800">{item.name}</span>
                        <span className="mx-1.5">·</span>
                        {item.role}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div>
                <h3 className="font-heading text-lg text-foreground-950">联系我们</h3>
                <p className="mt-1 text-sm text-foreground-600">
                  纠错、投稿、合作都欢迎：<br className="sm:hidden" />
                  <a
                    href="mailto:hello@guatian-suudi.example.com"
                    className="text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    hello@guatian-suudi.example.com
                  </a>
                </p>
              </div>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-edit-2-line" aria-hidden="true"></i>
                去留言
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}